import LoginForm from '../components/auth/LoginForm';

function LoginPage() {
  return (
    <div className="p-4">
      <LoginForm />
    </div>
  );
}

export default LoginPage;
